<template>
  <router-view/>
</template>


<script setup lang="ts">
import {nextTick, onBeforeMount, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";

const routerViewContainer = ref<HTMLElement | null>(null);

const isWechat = () => {
  return (String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === "micromessenger");
};

const route = useRoute()

</script>

<style>

</style>
